import { Settings, WidgetData } from './data'
import { Widget } from './widget'

export type VideoData = WidgetData & {
  settings: Settings & {
    hosted_url?: string
    poster_url?: string
  }
  widgetType: 'video'
}

export class VideoWidget extends Widget {
  hosted_url: string | undefined
  poster_url: string | undefined
  youtube_url: string | undefined

  constructor (data: any) {
    super(data)

    this.hosted_url = data.settings.hosted_url?.url
    this.poster_url = data.settings.poster?.url
    this.youtube_url = data.settings.youtube_url
  }
}
